export var getIsWithinReturnCompleteTimeframe = function (date) {
    var dateUpdated = new Date(date || '');
    var currentDate = new Date();
    // Checks whether the latest status update was less than 30 days ago
    return (currentDate.getTime() - dateUpdated.getTime() <= 30 * 24 * 60 * 60 * 1000);
};
